<div class="modal-body" data-backdrop="static">
  <form class="d-flex flex-column" #f="ngForm">
    <!-- El título está condicionado a cada paso  -->
    <div class="modal-header" style="text-align: center">
      <!-- <a href="#" class="text-dark" style="position: relative;" (click)="end(false)">
                <span class="gts-btn-icon-left">close</span>
            </a> -->
      <div class="col-lg-12">
        <button
          type="button"
          (click)="closeModalAndRemoveTracking(f)"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <h2>
          <b *ngIf="step_pi !== 9" style="font-size: 18px">{{
            iconTitle.title
          }}</b>
          <b *ngIf="step_pi == 9" style="font-size: 18px">Add Files</b>
        </h2>
        <br />
      </div>
    </div>
    <div class="form-container">
      <!-- Add New Processing Instructions  -->
      <div *ngIf="step_pi == 1" class="step-1">
        <mat-progress-bar
          style="width: 100%"
          *ngIf="loadingPo"
          id="loadingbar"
          mode="indeterminate"
        >
        </mat-progress-bar>
        <mat-form-field *ngIf="!loadingPo" class="example-full-width">
          <mat-label>Please select PO</mat-label>

          <input
            type="text"
            name="pobuscador"
            [(ngModel)]="pobuscador"
            placeholder="Please select PO"
            aria-label="Please select PO"
            matInput
            [formControl]="myControlClientes"
            [matAutocomplete]="autoClientes"
            required
          />
          <mat-autocomplete
            (optionSelected)="OnHumanSelected($event.option)"
            #autoClientes="matAutocomplete"
            [displayWith]="displayFn"
          >
            <mat-option
              *ngFor="let option of filteredClientes | async"
              [value]="option"
            >
              {{ option.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <p>
          Can't find PO? Click
          <button class="btn-sync bg-transparent border-0" (click)="sync()">
            <i *ngIf="syncpos" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            here
          </button>
          to SYNC all the POs from IQ
        </p>
        <p *ngIf="loadingTemplates">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          Loading Templates
        </p>
        <mat-form-field
          *ngIf="listTemplates && !loadingTemplates"
          class="mt-4"
          appearance="outline"
        >
          <mat-label>Select a Template</mat-label>
          <mat-select
            [formControl]="valueF"
            [(ngModel)]="selectedTemplate"
            (ngModelChange)="selectTemplates(selectedTemplate, $event)"
          >
            <mat-select-trigger>
              {{
                selectedTemplate == "none" ? "No template" : valueF.value.name
              }}
              <span
                class="deletetemplate"
                (click)="delete($event, value.valueF)"
              >
              </span>
            </mat-select-trigger>
            <mat-option value="none">No template</mat-option>
            <mat-option
              *ngFor="let template of listTemplates"
              [value]="template"
            >
              <div style="display: flex; justify-content: space-between">
                <span>{{ template.name }}</span>
                <span></span>
                <span class="deletetemplate" (click)="delete($event, template)">
                  <mat-icon>delete_forever</mat-icon>
                </span>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- 2 Transportation Details -->
      <div *ngIf="step_pi == 2" class="step-2 d-flex flex-column">
        <app-transportation-details
          [po_id]="item.po.id"
          [tableTrakings]="tableTrakings"
        >
        </app-transportation-details>
      </div>
      <!-- 3 PO Details -->
      <div *ngIf="step_pi == 3" class="step-2 grid-container">
        <!-- <app-purchasing-terms
        [selectedTerm]=""
        ></app-purchasing-terms>  -->
        <mat-form-field appearance="fill">
          <mat-label>Purchasing Terms</mat-label>
          <select
            [formControl]="terms"
            [(ngModel)]="selectedTerm"
            (ngModelChange)="selectTerms(selectedTerm, $event)"
            required
            name="net_terms"
            placeholder="Purchasing Terms"
            matNativeControl
          >
            <option value="" disabled>Select Purchasing Terms</option>
            <option *ngFor="let term of netTerms" [ngValue]="term">
              {{ term.name }}
            </option>
          </select>
        </mat-form-field>
        <div class="d-flex align-items-center w-100">
          <div class="form-group" *ngIf="item.netTerms == 'SORTANDSETTLE'">
            <label>Original Total Cost of the PO</label><br />
            <span>TBD</span>
          </div>
          <div class="d-flex w-100">
            <span class="pr-2" *ngIf="isRevenue == 0">$</span>
            <span class="pr-2" *ngIf="isRevenue == 1">%</span>
            <mat-form-field class="example-full-width">
              <mat-label>Original Total Cost of the PO</mat-label>

              <input
                type="number"
                min="0.01"
                step="0.01"
                id="original_total_cost_po"
                name="original_total_cost_po"
                [(ngModel)]="item.originalTotalCostPo"
                matInput
                placeholder="Original Total Cost of the PO"
                required
              />
            </mat-form-field>
          </div>
        </div>
        <mat-form-field appearance="fill">
          <mat-label>Has the equipment been sold?</mat-label>
          <select
            [(ngModel)]="item.hasTheEquipmentBeenSold"
            name="hasTheEquipmentBeenSold"
            matNativeControl
            required
            name="hasTheEquipmentBeenSold"
            id="hasTheEquipmentBeenSold"
            (ngModelChange)="selectChange('hasTheEquipmentBeenSold')"
            [disabled]="action == 'read' && !editar"
          >
            <option value="yesAll">Yes – All</option>
            <option value="yesParcial">Yes – Partial</option>
            <option value="No">No</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Breakdown Available</mat-label>
          <select
            name="inventory_manifest"
            id="inventory_manifest"
            [(ngModel)]="item.inventoryManifest"
            name="inventory_manifest"
            matNativeControl
            required
          >
            <!-- <option value="" disabled>Please select an option</option> -->
            <option value="yNote">Yes, inside notes.</option>
            <option value="yFile">Yes, inside files.</option>
            <option value="nBrea">No breakdown.</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Warranty</mat-label>
          <select
            name="warranty"
            [(ngModel)]="item.warranty"
            placeholder="Warranty"
            required
            matNativeControl
          >
            <option value="" disabled>Select Warranty</option>
            <option value="ASIS">AS-IS</option>
            <option value="1DAY">1 Day</option>
            <option value="5DAYS">5 Days</option>
            <option value="15DAYS">15 Days</option>
            <option value="30DAYS">30 Days</option>
            <option value="60DAYS">60 Days</option>
            <option value="6MONTHS">6 Months</option>
            <option value="1YEAR">1 Year</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label for="esgReportingRequired"
            >ESG Reporting Required</mat-label
          >
          <select
            (ngModelChange)="selectChange('esgReportingRequired')"
            name="esgReportingRequired"
            id="esgReportingRequired"
            [(ngModel)]="item.esgReportingRequired"
            required
            matNativeControl
          >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label for="typeReport">Physical Destruction Report</mat-label>
          <!-- (ngModelChange)="selectChange('typeReport')" -->
          <select
            name="typeReport"
            id="typeReport"
            [(ngModel)]="item.typeReport"
            required
            matNativeControl
          >
            <option value="basic">Basic</option>
            <option value="detailed">Detailed</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label for="buyer">Purchasing Rep</mat-label>
          <select
            name="buyer"
            [(ngModel)]="item.buyer.id"
            required
            matNativeControl
          >
            <option value="" disabled>Select Rep</option>
            <option *ngFor="let rep of repsList" [value]="rep.id">
              {{ rep.name }} {{ rep.surname }}
            </option>
          </select>
        </mat-form-field>
      </div>

      <!-- 4 Receiving Processing Instructions -->
      <div *ngIf="step_pi == 4" class="step-2">
        <div class="grid-container">
          <mat-form-field appearance="fill">
            <mat-label>Physical Destruction of Equipment?</mat-label>
            <select
              [(ngModel)]="item.all_cod"
              name="all_cod"
              matNativeControl
              required
              name="all_cod"
              id="all_cod"
              (ngModelChange)="selectChange('all_cod')"
            >
              <option value="NREQU">Not Required</option>
              <option value="Yes">All the equipment</option>
              <option value="No">Some of the equipment</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Sort Equipment</mat-label>
            <select
              [(ngModel)]="item.sortEquipment"
              name="sortEquipment"
              matNativeControl
              required
              name="sortEquipment"
              id="sortEquipment"
              (ngModelChange)="selectChange('sortEquipment')"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Picture Required?</mat-label>
            <select
              [(ngModel)]="item.pictureRequired"
              name="pictureRequired"
              matNativeControl
              required
              name="pictureRequired"
              id="pictureRequired"
              (ngModelChange)="selectChange('pictureRequired')"
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Security Seal Picture Required?</mat-label>
            <select
              [(ngModel)]="item.securitySealPictureRequired"
              name="securitySealPictureRequired"
              matNativeControl
              required
              name="securitySealPictureRequired"
              id="securitySealPictureRequired"
              (ngModelChange)="selectChange('securitySealPictureRequired')"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field class="" appearance="fill">
            <mat-label>Send straight to testing?</mat-label>
            <select
              [(ngModel)]="item.sendStraightToTesting"
              name="sendStraightToTesting"
              matNativeControl
              required
              name="sendStraightToTesting"
              id="sendStraightToTesting"
              (ngModelChange)="selectChange('sendStraightToTesting')"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="notesForReceiving">Notes for receiving</label>
          <div class="form-group">
            <textarea
              name="notesForReceiving"
              #notesForReceiving="ngModel"
              [(ngModel)]="item.notesForReceiving"
              class="form-control"
              rows="2"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- 5 Manifest Processing Instructions -->
      <div *ngIf="step_pi == 5" class="step-2">
        <div class="grid-container">
          <mat-form-field appearance="fill" class="mr-4">
            <mat-label>Manifest Required?</mat-label>
            <mat-select
              name="manifestRequired"
              id="manifestRequired"
              [(ngModel)]="item.manifestRequired"
              required
              (ngModelChange)="selectChange('manifestRequired')"
            >
              <mat-option value="null" disabled>
                Please select an option
              </mat-option>
              <mat-option value="yesDetailedManifest">
                Yes - Detailed Manifest
              </mat-option>
              <mat-option value="noReportingRequired">
                No – No Reporting Required
              </mat-option>
              <mat-option value="noCertificateDisposalOnly">
                No – Certificate of Disposal Only
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            *ngIf="
              item.manifestRequired == 'noReportingRequired' ||
              item.manifestRequired == 'noCertificateDisposalOnly' ||
              item.manifestRequired == 'No'
            "
            class=""
          >
            <mat-form-field appearance="fill" class="mr-4">
              <mat-label>No Manifest Priority Level</mat-label>
              <select
                name="no_manifest_priority_level"
                [(ngModel)]="item.no_manifest_priority_level"
                placeholder="No Manifest Priority Level"
                matNativeControl
                [disabled]="action == 'read' && !editar"
                required
              >
                <option value="" disabled>Select Priority</option>
                <option value="No Manifest - 30 Days">
                  No Manifest - 30 Days
                </option>
                <option value="No Manifest - 15 Days">
                  No Manifest - 15 Days
                </option>
                <option value="No Manifest - 7 Days">
                  No Manifest - 7 Days
                </option>
                <option value="No Manifest - 1 Day">No Manifest - 1 Day</option>
              </select>
            </mat-form-field>
          </div>
          <mat-form-field
            *ngIf="
              item.manifestRequired == 'Yes' ||
              item.manifestRequired == 'yesDetailedManifest'
            "
            appearance="fill"
          >
            <mat-label>Manifest Priority Level </mat-label>
            <select
              [(ngModel)]="item.manifest_priority_level"
              name="manifest_priority_level"
              matNativeControl
              required
              name="manifest_priority_level"
              id="manifest_priority_level"
              (ngModelChange)="selectChange('manifest_priority_level')"
            >
              <option value="" disabled>Select Priority</option>
              <!--<option value="NOMANIFEST">No Manifest</option>-->
              <option value="LOWPRIORITY">Low Priority - 30 Days</option>
              <option value="MEDIUMPRIORITY">Medium Priority - 15 Days</option>
              <option value="FASTPRIORITY">Fast Priority - 7 Days</option>
              <option value="URGENTPRIORITY">Urgent Same Day - 1 Day</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label for="dataDestructionRequired"
              >Data Destruction Required?</mat-label
            >
            <select
              name="dataDestructionRequired"
              matNativeControl
              id="dataDestructionRequired"
              [(ngModel)]="item.dataDestructionRequired"
              required
            >
              <option value="null" disabled>Please select an option</option>
              <option value="yesDataDestruction">Yes – Data Destruction</option>
              <option value="noDataDestruction">No – Data Destruction</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Pull Hard Drives?</mat-label>
            <select
              [(ngModel)]="item.pullHardDrives"
              name="pullHardDrives"
              matNativeControl
              required
              name="pullHardDrives"
              id="pullHardDrives"
              (ngModelChange)="selectChange('pullHardDrives')"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hard Drive Shredding?</mat-label>
            <select
              [(ngModel)]="item.hdShredding"
              name="hdShredding"
              matNativeControl
              required
              name="hdShredding"
              id="hdShredding"
              (ngModelChange)="selectChange('hdShredding')"
            >
              <!-- <option value="null">Please select an option</option> -->
              <option value="NREQU">Not Required</option>
              <option value="Yes">Some Hard Drives</option>
              <option value="No">All the Hard Drives</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hold Equipment?</mat-label>
            <select
              [(ngModel)]="item.holdDefectiveEquipment"
              name="hold_defective_equipment"
              matNativeControl
              required
              name="hold_defective_equipment"
              id="hold_defective_equipment"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="nothin">Nothing</option>
              <option value="defec">Defective Equipment Only</option>
              <option value="every">Everything</option>
            </select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="notesForManifest">Notes for Manifest </label>
          <div class="form-group">
            <textarea
              name="notesForManifest"
              #notesForManifest="ngModel"
              [(ngModel)]="item.notesForManifest"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- 6 Testing Processing Instructions -->
      <div *ngIf="step_pi == 6" class="step-2">
        <div class="grid-container">
          <mat-form-field appearance="fill">
            <mat-label>Testing Report Required</mat-label>
            <select
              (ngModelChange)="selectChange('testingReportRequired')"
              [(ngModel)]="item.testingReportRequired"
              name="testingReportRequired"
              matNativeControl
              required
              name="testingReportRequired"
              id="testingReportRequired"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Testing Priority Level</mat-label>
            <select
              [(ngModel)]="item.poPriorityLevel"
              name="po_priority_level"
              matNativeControl
              required
              name="po_priority_level"
              id="po_priority_level"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="null" disabled>Select Priority</option>
              <option value="LOWPRIORITY">Low Priority</option>
              <option value="MEDIUMPRIORITY">Medium Priority</option>
              <option value="FASTPRIORITY">Fast Priority</option>
              <option value="URGENTPRIORITY">Urgent Same Day</option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Sort and Settle?</mat-label>
            <select
              [(ngModel)]="item.sortAndSettle"
              name="sort_and_settle"
              matNativeControl
              required
              name="sort_and_settle"
              id="sort_and_settle"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label class="bmd-label-floating">Notes for Techs:</label>
          <div class="form-group">
            <textarea
              name="description_techs"
              #description_techs="ngModel"
              [(ngModel)]="item.description_techs"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- 7 Data Sanitization Processing Instructions -->
      <div *ngIf="step_pi == 7" class="step-2">
        <div class="grid-container">
          <mat-form-field appearance="fill">
            <mat-label>Erasure Method</mat-label>
            <select
              (ngModelChange)="selectChange('passDataErasure1')"
              [(ngModel)]="item.passDataErasure1"
              name="passDataErasure1"
              matNativeControl
              required
              name="passDataErasure1"
              id="passDataErasure1"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option *ngFor="let item of erasureMethods" [value]="item.name">
                {{ item.name }}
              </option>
            </select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Hold Bad Hard Drives?</mat-label>
            <select
              (ngModelChange)="selectChange('holdBadHardDrives')"
              [(ngModel)]="item.holdBadHardDrives"
              name="holdBadHardDrives"
              matNativeControl
              required
              name="holdBadHardDrives"
              id="holdBadHardDrives"
            >
              <!-- <option value="" disabled>Please select an option</option> -->
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label for="notesForWiping" class="bmd-label-floating"
            >Notes for Data Sanitization</label
          >
          <div class="form-group">
            <textarea
              name="notesForWiping"
              #notesForWiping="ngModel"
              [(ngModel)]="item.notesForWiping"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- 8 Sales Processing Instructions -->
      <div *ngIf="step_pi == 8" class="step-2">
        <div class="form-group">
          <label class="bmd-label-floating">Notes for Sales</label>
          <div class="form-group">
            <textarea
              name="notesForSales"
              #notesForSales="ngModel"
              [(ngModel)]="item.notesForSales"
              class="form-control"
              rows="5"
              [readonly]="action == 'read' && !editar"
            ></textarea>
          </div>
        </div>
      </div>
      <div
        style="width: 90%; padding: 20px; margin: 0 auto"
        *ngIf="step_pi == 9"
      >
        <p>Would you like to add files to this PI now?</p>
        <app-multi-files
          [idfather]="idPi"
          [type]="'FILESPROCESSING'"
          [poNumber]="item.po.name"
        ></app-multi-files>
      </div>
    </div>
    <div class="form-check d-flex align-self-end" *ngIf="step_pi == 8">
      <label class="form-check-label">
        <input
          [checked]="saveAsTemplate"
          name="hidep"
          [(ngModel)]="item.saveAsTemplate"
          (change)="showTemplateForm(item.saveAsTemplate)"
          class="form-check-input"
          type="checkbox"
        />
        Save as a template
        <span class="form-check-sign">
          <span class="check"></span>
        </span>
      </label>
    </div>
    <mat-form-field
      *ngIf="showTemplate && step_pi == 8"
      class="example-full-width"
    >
      <mat-label>Template Name</mat-label>

      <input
        type="text"
        id="templateName"
        name="templateName"
        [(ngModel)]="item.templateName"
        matInput
        placeholder="Template Name"
        required
      />
    </mat-form-field>

    <!-- <mat-form-field class="example-full-width"
    *ngIf="showTemplate && step_pi == 8"
    >
      <mat-label>Template Name</mat-label>

      <input
        type="text"
        name="templateName"
        [(ngModel)]="item.templateName"
        placeholder="Select Template"
        aria-label="Select Template"
        matInput
        [formControl]="myControlTemplates"
        [matAutocomplete]="autoTemplates"
        required
      />
      <mat-autocomplete
        (optionSelected)="selectTemplate($event.option)"
        #autoTemplates="matAutocomplete"
        [displayWith]="displayFnT"
      >
        <mat-option
          *ngFor="let template of listTemplates"
          [value]="template"
        >
          {{ template.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>  -->
    <div class="d-flex align-self-end">
      <button
        *ngIf="step_pi > 1 && step_pi !== 9"
        (click)="changeStep('previous')"
        class="align-self-end bg-transparent border-0 mr-4 btn-nav"
      >
        <i class="material-icons">navigate_before</i>
        Previous
      </button>
      <button
        *ngIf="step_pi < 8"
        (click)="changeStep('next')"
        class="align-self-end bg-transparent border-0 btn-nav"
        [disabled]="
          (!selectedPoOption && frompo == 'No') ||
          !pobuscador ||
          isDisabled ||
          loadingPo
        "
      >
        Next
        <i class="material-icons">navigate_next</i>
      </button>
      <button
        [disabled]="!pobuscador || guardando || isDisabled"
        *ngIf="step_pi == 8"
        (click)="save(f)"
        class="align-self-end btn gts-btn-primary"
      >
        Save
      </button>
      <button
        *ngIf="step_pi == 9"
        (click)="closeModalAndRemoveTracking(f)"
        class="align-self-end btn gts-btn-primary-outline"
      >
        close
      </button>
    </div>
  </form>
</div>

<div
  class="modal"
  id="templateModal"
  role="dialog"
  tabindex="-1"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <div class="modal-body">
        <p>
          This template already exists. Do you want to update
          <strong>"{{ item.templateName }}"</strong> template before saving?
        </p>
      </div>
      <div class="modal-footer" style="text-align: center">
        <button
          type="button"
          [disabled]="guardando"
          class="btn btn-success mr-2"
          (click)="saveAndUpdate()"
        >
          Yes
        </button>
        <button
          type="button"
          [disabled]="guardando"
          class="btn btn-info mr-2"
          (click)="savePI()"
        >
          No
        </button>
        <button
          type="button"
          [disabled]="guardando"
          class="btn btn-danger"
          (click)="cancelSaveTemplate()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
<!-- <div
  class="modal"
  id="templateModal"
  role="dialog"
  tabindex="-1"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <div class="modal-body">
        <p>
          Add files to the PI of PO #{{item.po.name}} 
        </p>
          <app-multi-files
            [idfather]="idPi"
            [type]="'FILESPROCESSING'"
            [poNumber]="item.po.name"
            (total)="numFiles = $event"
          ></app-multi-files>
      </div>
      <div class="modal-footer" style="text-align: center">
        <button
          type="button"
          [disabled]="guardando"
          class="btn btn-danger"
          (click)="cancelSaveTemplate()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="modal-body">

</div> -->
